import { render, staticRenderFns } from "./MaterialGroups.vue?vue&type=template&id=1f88532b&scoped=true&"
import script from "./MaterialGroups.vue?vue&type=script&lang=js&"
export * from "./MaterialGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88532b",
  null
  
)

export default component.exports